import React from 'react';
import './KioskoComponents.css';
import BotonKiosko from './BotonKiosko';

const MensajeModal = ({ visible, titulo, mensaje, onConfirm, tipo = 'info' }) => {
    if (!visible) return null;

    return (
        <div className="modal-kiosko-overlay">
            <div className={`modal-kiosko-content animate-pop ${tipo}`}>
                <h2 className="modal-kiosko-title">{titulo}</h2>
                <p className="modal-kiosko-msg">{mensaje}</p>
                <div className="modal-kiosko-footer">
                    <BotonKiosko
                        texto="ENTENDIDO"
                        color={tipo === 'error' ? 'red' : 'blue'}
                        onClick={onConfirm}
                        tamano="grande"
                    />
                </div>
            </div>
        </div>
    );
};

export default MensajeModal;
